import { render, staticRenderFns } from "./DomainDnsRecord.vue?vue&type=template&id=7abb4a7c"
import script from "./DomainDnsRecord.vue?vue&type=script&lang=js"
export * from "./DomainDnsRecord.vue?vue&type=script&lang=js"
import style0 from "./DomainDnsRecord.vue?vue&type=style&index=0&id=7abb4a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports